import { Expedition } from '../types';

/**
 * Orden oficial de visualización de expediciones por ID.
 * En la categoría Trekking se sigue un orden estrictamente geográfico y de jerarquía de producto:
 * 1. Travesía Las Horquetas (Signature de 4 días en Parque Nacional Cerro Castillo)
 * 2. Trekking Laguna Cerro Castillo (Icónico Full Day dentro del Parque Nacional Cerro Castillo)
 * 3. Trekking Laguna Yagan (2 días / 1 noche dentro del Parque Nacional Cerro Castillo)
 * 4. Trekking Torres del Avellano, Bahía Murta (Región de Aysén, fuera del PN Cerro Castillo)
 * 5. Ice Trekking Glaciar Exploradores (Región de Aysén)
 * 6. Trekking W Torres del Paine (Región de Magallanes, extremo sur)
 */
export const EXPEDITION_ORDER: Record<string, number> = {
    // --- TREKKING (Orden Geográfico / Relevancia) ---
    'horquetas': 10,
    'laguna': 20,
    'laguna-yagan': 30,
    'torres-del-avellano': 40,
    'ice-trekking-exploradores': 45,
    'torres-del-paine-w': 50,

    // --- ESCALADA (Cerro Castillo -> Coyhaique -> Chile Chico) ---
    'escalada-en-roca-cerro-castillo': 110,
    'ice-climbing-portezuelo': 120,
    'rock-climbing': 130,
    'trad-climbing-cerro-colorado': 140,

    // --- AGUA / NAVEGACIÓN ---
    'marmol': 210,
    'kayak-tranquilo': 220,
    'fly-fishing': 230,

    // --- BIENESTAR ---
    'wellness': 310,
};

export function sortExpeditions(list: Expedition[]): Expedition[] {
    if (!Array.isArray(list)) return [];
    return [...list].sort((a, b) => {
        const orderA = EXPEDITION_ORDER[a.id] ?? 999;
        const orderB = EXPEDITION_ORDER[b.id] ?? 999;
        if (orderA !== orderB) return orderA - orderB;
        const timeA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const timeB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return timeA - timeB;
    });
}
